import { orderDetailState } from "@/atoms/order/order-detail-state";
import { GLOBAL_ERROR } from "@/common/constant/global-error";
import { Footnote12Description } from "@/components/typography/Footnote12Description";
import { orderService } from "@/services/order-service2";
import { HistoryDto } from "@/types/dto/history-dto";
import { TableHeader } from "@/types/table-header";
import { Table } from "flowbite-react";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { CustomCell } from "../CustomCell";
import { PartnerOrderStatusRow } from "./PartnerOrderStatusRow";

const headers: TableHeader[] = [
  { title: "일자", width: "w-[408px]" },
  { title: "발주 상태", width: "w-[408px]" },
];

export const PartnerOrderStatusTable = () => {
  const [orderDetail, setOrderDetail] = useRecoilState(orderDetailState);
  const [patchnote, setPatchnote] = useState<HistoryDto[]>([]);

  const getPatchnote = async () => {
    if (!orderDetail) {
      return;
    }

    const response = await orderService.getPatchNotes(orderDetail.id);
    if (!response.ok) {
      return alert(GLOBAL_ERROR);
    }
    setPatchnote(response.data);
  };

  useEffect(() => {
    getPatchnote();
  }, []);

  return (
    <div className="w-[816px] overflow-x-auto rounded-lg border">
      <Table>
        <Table.Head className="p-0 border-b">
          {headers.map((header) => (
            <Table.HeadCell
              key={header.title}
              className={header.width + " h-[52px]"}
            >
              <div className={header.align}>
                <CustomCell>
                  <Footnote12Description
                    className={"text-semantic-text-secondary"}
                  >
                    {header.title}
                  </Footnote12Description>
                </CustomCell>
              </div>
            </Table.HeadCell>
          ))}
        </Table.Head>
        <Table.Body className="divide-y">
          {patchnote.map((item, index) => (
            <PartnerOrderStatusRow key={item.id} data={item} />
          ))}
        </Table.Body>
      </Table>
    </div>
  );
};
